import styles from "./Labels.module.css";
import InputHeader from "../input/InputHeader";
import InputCard from "../containers/InputCard";

const LatLong = ({ locationObject }) => {
  return (
    <InputCard>
      <InputHeader text="Location" />
      <div className={styles.infoTextDiv}>
        <p
          className={styles.infoText}
          id="userLatitude"
          name="userLatitude"
        >{`(${locationObject?.latitude},`}</p>
        <p
          className={styles.infoText}
          id="userLongitude"
          name="userLongitude"
        >{`${locationObject?.longitude})`}</p>
      </div>
    </InputCard>
  );
};

export default LatLong;
